import { createAsyncThunk } from '@reduxjs/toolkit';
import { EDealType } from '../../repositories/cpd/entities/v1_create_cpd_draft/PublicV1CreateCpdDraftRequest';
import { fetchCreateCpdDraft, TCreateCpdDraftResponse } from '../../repositories/cpd/v1/create-cpd-draft';
import { HttpBadStatusCodeError } from '@cian/peperrors';
import { IThunkApi } from '../../types/redux';
import { selectQueryString } from '../../selectors/page';

interface ISendFormParams {
  source: 'seoLandingPageForm' | 'seoLandingPageConsultation';
  dealType: EDealType;
  regionId: number;
  phone: string;
  legalAgreementAccepted: boolean;
}

export const sendForm = createAsyncThunk<number | null, ISendFormParams, IThunkApi>(
  'form/sendForm',
  async ({ source, regionId, dealType, phone, legalAgreementAccepted }, _thunkApi) => {
    const {
      getState,
      extra: { logger, httpApi },
    } = _thunkApi;

    const state = getState();
    const qs = selectQueryString(state);

    try {
      const res = (await fetchCreateCpdDraft({
        httpApi,
        parameters: {
          source,
          regionId,
          dealType,
          legalAgreementAccepted,
          phone: `+7${phone}`,
          cianSource: qs.cianSource,
        },
      })) as TCreateCpdDraftResponse;

      if (res.statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          statusCode: res.statusCode,
          domain: 'sendForm.ts',
          message: res.response.message,
        });
      }

      return res.response.cpdDraftId;
    } catch (e) {
      logger.debug('Ошибка отправки формы ОС', {
        message: e.message,
        domain: e.domain,
      });

      return null;
    }
  },
);
